import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

export const OrderDetailsPage = styled.div``;

export const TitleRow = styled.div`
  margin-left: 2.5rem;
  margin-top: 2.5rem;
`;

export const Title = styled.span`
  color: #001758;
  font-family: 'Lato-Light', sans-serif;
  font-size: 2.5rem;
  line-height: 3.1rem;
  margin-right: 1rem;
`;

export const TitleImage = styled.img`
  vertical-align: bottom;
  width: 2.5rem;
`;

export const OrderTable = styled.table`
  margin-left: 3.5rem;
  margin-bottom: 2.5rem;

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

export const Link = styled.a`
  &,
  &:visited,
  &:active,
  &:hover {
    color: #7f7f7f;
    text-decoration: underline;
  }
`;

export const TableTBody = styled.tbody``;
export const TableTr = styled.tr``;
export const TableTd = styled.td`
  color: #7f7f7f;
  line-height: 1.8rem;

  &:first-child {
    border-right: 1px solid #ddd;
    font-family: 'Lato-Bold', sans-serif;
    font-weight: 700;
    padding: 0.5rem 2rem 0.5rem 0.5rem;
    text-align: right;
  }

  &:last-child {
    font-family: 'Lato-Light', sans-serif;
    font-weight: 300;
    padding: 0.5rem 0.5rem 0.5rem 2rem;
    text-align: left;
  }
  &.order-item-prop:last-child {
    padding-left: 3.5rem;
  }
`;

export const HeaderRow = styled.div`
  padding: 32px;
  border-bottom: 1px solid ${colors.lightGray6};
`;
